export default function () {
  return {
    // All packages from API
    packages: [],
    // Pagination metadata
    pagination: {
      currentPage: 1,
      perPage: 50,
      total: 0,
    },
    // Active filters
    filters: {
      licenseId: null,
      productId: null,
      status: null, // 'excluded', 'custom_mapped', 'active', or null for all
      search: "",
    },
    // Selected package keys (license_id:tag)
    selectedKeys: [],
    // Loading states
    loading: true,
    actionLoading: false,
  };
}
